import React, { useContext, useEffect } from 'react';
import DEFAULTS from '../../../constants/pricing/defaults';
import { SIGNUP_URL } from '../../../constants/pricing/config';
import PricingContext from '../../../context/pricing';
import { setAddons } from '../../../actions/pricing';
import { trackCheckout } from '../../../utils/pricing';
import { dataLayerPush } from '../../../utils';
import withSelections from '../withSelections';
import Addon from './Addon';

const Addons = ({ eiPackage, mcPackage, easeAdded, ipAdded }) => {
  const { dispatch, state, sgPricingVersion } = useContext(PricingContext);
  const isEase =
    (eiPackage && eiPackage.allowedAddons.ease) ||
    (mcPackage && mcPackage.allowedAddons.ease);
  const isIP =
    (eiPackage && eiPackage.allowedAddons.ip) ||
    (mcPackage && mcPackage.allowedAddons.ip);
  const buttonText =
    easeAdded || ipAdded ? 'Continue to Checkout' : 'Continue Without Add-ons';

  let ipBadgeCopy = '';

  if (!isIP) {
    if (eiPackage) {
      ipBadgeCopy += 'Pro';
    }
    if (eiPackage && mcPackage) {
      ipBadgeCopy += ' / ';
    }
    if (mcPackage) {
      ipBadgeCopy += 'Advanced';
    }
    ipBadgeCopy += ' Only';
  }

  const eiBadgeCopy =
    eiPackage && !eiPackage.ease ? 'Paid API Plans Only' : false;

  const handleEaseClick = () => {
    setAddons('ease', easeAdded ? 3 : 30, dispatch);
    const eventAction = easeAdded ? 'remove_addon' : 'add_addon';
    dataLayerPush({
      event: 'pricingFunnel',
      eventAction,
      pricingVersion: sgPricingVersion,
      pricingTab: state.activeTab,
      addonName: 'ease', // name of product
    });
  };

  const handleIPClick = () => {
    setAddons('ip', ipAdded ? 0 : 1, dispatch);
    const eventAction = ipAdded ? 'remove_addon' : 'add_addon';
    dataLayerPush({
      event: 'pricingFunnel',
      eventAction,
      pricingVersion: sgPricingVersion,
      pricingTab: state.activeTab,
      addonName: 'ip', // name of product
    });
  };

  /**
   * If IPs or EASE is _not_ supported by the combination of plans,
   * disable the addon. Set addons to default state on component unmount.
   */
  useEffect(() => {
    if (!isIP) {
      setAddons('ip', DEFAULTS.addons.ip, dispatch);
    }
    if (!isEase) {
      setAddons('ease', DEFAULTS.addons.ease, dispatch);
    }
    return () => {
      setAddons('ip', DEFAULTS.addons.ip, dispatch);
      setAddons('ease', DEFAULTS.addons.ease, dispatch);
    };
  }, [isIP, isEase]);

  return (
    <div className="addon">
      {eiPackage && (
        <Addon
          id="ease"
          rate={eiPackage ? eiPackage.ease : 0}
          isDisabled={!isEase}
          isAdded={easeAdded}
          badgeCopy={eiBadgeCopy}
          handleClick={handleEaseClick}
          title="30 Days of Email Activity History"
          description={`${
            eiPackage.easeIncluded || 3
          } days included with your plan. Gain further insights with additional history and API access.`}
        />
      )}
      <Addon
        id="ip"
        rate={30}
        isDisabled={!isIP}
        isAdded={ipAdded}
        badgeCopy={ipBadgeCopy}
        handleClick={handleIPClick}
        title="1 Additional Dedicated IP Address"
        description="Take full control over your deliverability, distribute your mail traffic across multiple IPs."
      />
      <div className="modal-footer row row--small text-center m-top-3">
        <a
          className="btn btn--primary"
          data-testid="continue-to-signup"
          onClick={() => trackCheckout(state, sgPricingVersion)}
          href={SIGNUP_URL}
        >
          {buttonText}
        </a>
        <small className="block m-top-2 m-bottom-1 is-size-12">
          *Taxes and overages may apply.
        </small>
      </div>
    </div>
  );
};
export default withSelections(Addons);
